export default function calcSum(array: number[]) {
  return  array.reduce((a, x) => a + x, 0);
}